import api from './utils/api';

class UpgradesService {
  async listUpgrades(order) {
    const params = new URLSearchParams({ order });

    const result = await api.get(`/upgrades?${params.toString()}`);
    const { data } = result;

    // Garantir que sempre retorna um array
    if (Array.isArray(data)) {
      return data;
    }

    // Se a API retornar { upgrade: [...] } ou { upgrades: [...] }
    if (data && Array.isArray(data.upgrade)) {
      return data.upgrade;
    }

    if (data && Array.isArray(data.upgrades)) {
      return data.upgrades;
    }

    console.error('UpgradesService: API retornou formato inesperado:', data);
    return [];
  }

  async activeBoost({ modelId, upgradeId }) {
    const result = await api.put('/model-upgrades', { modelId, upgradeId });

    return result.data;
  }

  async findById(id) {
    const result = await api.get(`/upgrades/${id}`);
    return result.data;
  }

  async update(id, data) {
    const result = await api.put(`/upgrades/${id}`, data);
    return result.data;
  }
}

export default new UpgradesService();
